import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { setDrawer } from "../redux-store/features/layoutSlice";
import {
  MAX_REJECT_REASON_LENGTH,
  normalizeRejectReason,
  validateRejectReason,
} from "../utils/rejectReason";

export default function ModalWithTextBox({
  open,
  setOpen,
  onClick,
  id,
  refetch,
  vqaDetailsRefetch,
}) {
  const [reason, setInputValue] = useState("");
  const [touched, setTouched] = useState(false);
  const dispatch = useDispatch();
  const error = validateRejectReason(reason);
  const showError = touched && Boolean(error);
  const handleSubmit = () => {
    onClick(
      { id, reason: normalizeRejectReason(reason) },
      {
        onSuccess: () => {
          dispatch(setDrawer(true));
          setOpen(false);
          setInputValue("");
          setTouched(false);
          // setMessage("Request Rejected");
          // status("error");
          refetch();
        },
        onError: () => {
          setOpen(false);
          // status("error");
          // setMessage(rejectError?.response?.data.message);
        },
      }
    );
    setOpen(false); // Close modal after submission
  };

  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-yellow-100">
                <ExclamationTriangleIcon
                  aria-hidden="true"
                  className="size-6 text-yellow-600"
                />
              </div>
              <div className="mt-3 text-center sm:mt-5">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold text-gray-900"
                >
                  Reject
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Please enter your reason to reject.
                  </p>
                  <input
                    type="text"
                    required
                    value={reason}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                      setTouched(true);
                    }}
                    onBlur={() => setTouched(true)}
                    aria-label="Reason to reject"
                    aria-invalid={showError}
                    aria-describedby="reject-reason-feedback"
                    placeholder="Type here..."
                    className="mt-3 w-full rounded-md border-gray-300 p-2 text-sm text-gray-900 focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <div
                    id="reject-reason-feedback"
                    className="mt-1 flex justify-between gap-2 text-left text-xs"
                  >
                    <span role="alert" className="text-red-600">
                      {showError ? error : ""}
                    </span>
                    <span className="shrink-0 text-gray-500">
                      {normalizeRejectReason(reason).length}/{MAX_REJECT_REASON_LENGTH}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-6">
              <button
                disabled={Boolean(error)}
                type="button"
                onClick={handleSubmit}
                className={`inline-flex w-full justify-center rounded-md ${
                  error ? "bg-gray-600" : "bg-indigo-600"
                } px-3 py-2 text-sm font-semibold text-white shadow-sm ${
                  error
                    ? "hover:bg-gray-600"
                    : "hover:bg-indigo-600"
                } focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
              >
                Submit
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
